import React from "react";
import classNames from 'classnames'



export default function CartItems(props) {


  
  return (
    
    <section className="col-12 mb-3">
      {console.log(props.item)}
      <h6 className="text-center my-3">{props.item.title}</h6>
      <div className="row justify-content-center">
        <div className="col-6 pl-5 pr-0">
          <h6 className="card-subtitle small text-center">Travellers</h6>
          <div className="small">
            <div className="mt-2 mb-0 row cart-travelers">
              <p className="col-7">Adults: </p>
              <p className="col-4">
                {props.item.adultCount}
              </p>
            </div>
            <div className="my-0 row cart-travelers border-bottom">
              <p className={classNames("col-7", props.item.childrenCount === 0 ? 'hidden' : '')}>Childrens: </p>
              <p className={classNames('col-4', props.item.childrenCount === 0 ? 'hidden' : '')}>{props.item.childrenCount}</p>
            </div>
            <div className="mt-2 mb-0 row cart-travelers">
              <p className='col-7'>Total: </p>
              <p className='col-4'>{props.item.totalTravelers}</p>
            </div>
          </div>
        </div>

        <div className="col-6 pl-0 pr-5">
          <h6 className="card-subtitle small text-center">Cost</h6>
          <div className="small text-center">
            <p className="mt-2 mb-0 cart-travelers">
              ${props.item.adultCount * props.item.tripPriceAdult}
            </p>
            <div className='m-0 border-bottom cart-travelers'>
            <p className={classNames("", props.item.childrenCount === 0 ? 'hidden' : '')}>
              ${props.item.childrenCount * props.item.tripPriceChildren}
            </p>

            </div>
            <p className="mt-2 mb-0 cart-travelers">${props.item.total}</p>
          </div>
        </div>
        <h6 className='small col-12 text-center my-3'>Additional features</h6>
        <div className='col-6 pl-5 pr-0 small'>
        <p className={classNames('my-0', props.item.choosenPickUp == 0 || props.item.choosenPickUp === '' || props.item.choosenPickUp === props.item.standardPickUp ? 'hidden' : '')}>Airport pick-up</p>
        <p className={classNames('my-0', props.item.choosenTripOption == 0 || props.item.choosenTripOption === '' || props.item.choosenTripOption === props.item.tripStandard ? 'hidden' : '')}>More tours</p>
        <p className={classNames('my-0', props.item.choosenHotel == 0 || props.item.choosenHotel === '' || props.item.choosenHotel === props.item.hotelStandard ? 'hidden' : '')}>Different hotel</p>

        </div>
        <div className="col-6 pl-0 pr-5 text-center small">
        <p className={classNames('my-0', props.item.choosenPickUp == 0 || props.item.choosenPickUp === '' || props.item.choosenPickUp === props.item.standardPickUp ? 'hidden' : '')}>${props.item.choosenPickUp}</p>
        <p className={classNames('my-0', props.item.choosenTripOption == 0 || props.item.choosenTripOption === '' || props.item.choosenTripOption === props.item.tripStandard ? 'hidden' : '')}>${props.item.choosenTripOption}</p>
        <p className={classNames('my-0', props.item.choosenHotel == 0 || props.item.choosenHotel === '' || props.item.choosenHotel === props.item.hotelStandard ? 'hidden' : '')}>${props.item.choosenHotel}</p>
        </div>
        <div classNames={classNames('col-12 text-center my-3',)}><p className={classNames('m-0',props.item.choosenPickUp == 0  && props.item.choosenTripOption == 0 && props.item.choosenHotel == 0 ? '' : 'hidden' )}>None</p> </div>
      </div>
        <div className='d-flex col-12 mt-3 justify-content-center'>
        <h6 className='small mr-2'>Total price for this trip:</h6>
        <h6 className='small'>${+props.item.total <= +props.item.totalWithOptions ? parseFloat(props.item.totalWithOptions).toFixed(2) : props.item.total}</h6>

        </div>
        <div className='text-center'>
          <button className='btn btn-danger btn-sm' onClick={e => props.removeFromCart(props.item.id, e)}>Remove from cart</button>
        </div>
        <hr />
    </section>
  );
}

